// UI elements functionality

import AjaxForm from './forms';

class UI {
    // reference to app.js
    constructor(app) {
        this.bind();
    }

    bind() {
        $('form.ajax-form').on('submit', event => new AjaxForm($(event.target), event).submitForm());
        $('table.table').on('click', '.confirm-action', this.onConfirmActionClick);
    }

    onConfirmActionClick() {
        var $this = $(this);
        var $target = $($this.data('target'));
        $target.find('.target-action').attr('action', $this.data('action'));
    }

}

export default UI;